import {useEffect, useRef, useState} from "react";
import * as React from "react";
import clsx from "clsx";

type FilterInputProps = {
    filterText?: string;
    isChanged: boolean;
    placeholder: string;
    setFocus: number;
    inProgress: boolean;

    onTextChanged: (text: string, memorize: boolean) => void;
}

export default (props: FilterInputProps) => {

    const inputRef = useRef(null);

    useEffect(() => {
        if (props.filterText) {
            inputRef.current.select();
        }

        // Should be fast to quickly catch typing after pressing shift+shift
        inputRef.current.focus();

    }, [props.setFocus]);

    const should_highlight = () => !props.isChanged && props.filterText
    const onTextChanged = (newValue, persist) => {
        props.onTextChanged(newValue, persist)
    }

    const clearField = () => {
        if (props.filterText) {
            onTextChanged("", true)
            return true;
        }
        return false;
    }
    const clearOnEsc = (e) => {
        if (e.key === "Escape" && clearField()) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (e.altKey) {
            // To allow processing mnemonics
            e.preventDefault();
        }
    }

    let fieldIconCss = clsx("popupFlt__icon",
        props.inProgress ? "far fa-spinner fa-spin" : props.filterText ? "far fa-times" : "far fa-search");

    return <div className="popupFlt">
        <input ref={inputRef} onKeyDown={clearOnEsc}
               className={`popupFilter${should_highlight() ? " popupFilter--highlight" : ""}`}
               placeholder={props.placeholder}
               value={props.filterText}
               onChange={(event) => {onTextChanged(event.target.value, false)}}
        />
        <i className={fieldIconCss} onClick={clearField}/>
    </div>
}
